<template>
  <div class="echarts-box" ref="box"></div>
</template>
<script>
const loadEcharts = () => {
  return new Promise(resolve => {
    (() => import(/* webpackChunkName: "echarts" */ 'echarts'))().then((echarts) => {
      resolve(echarts);
    });
  });
};

export default {
  components: {},
  props: {
    option: Object,
  },
  data() {
    return {
      echarts: null,
      chartIns: null,
      resizeTimeout: null
    };
  },
  computed: {},
  watch: {
    option() {
      if (this.chartIns) {
        this.chartIns.setOption(this.option);
      }
    }
  },
  methods: {
    initChartIns() {
      this.chartIns = this.echarts.init(this.$refs.box);
      if (this.option) {
        this.chartIns.setOption(this.option);
      }
    },
    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        if (this.chartIns) {
          this.chartIns.resize({
            animation: {
              duration: 200
            }
          });
        }
      }, 500);
    }
  },
  created() {
  },
  async mounted() {
    this.echarts = await loadEcharts();
    console.log('this.echarts', this.echarts);
    this.initChartIns();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="scss" scoped>

</style>
